import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_popover.scss'

import { Props, DivAttributes, PlacementNS } from '../utils/types'
import addSubcomponents from '../utils/addSubcomponents'
import isReactElement from '../utils/isReactElement'
import { OverlayTriggerPlacement } from '../state/OverlayTrigger'
import { OverlayTriggerAdapter as OverlayTrigger } from './OverlayTriggerAdapter'

const cx = bind(styles)

interface ContentProps extends Props {
  children?: React.ReactNode
  placement?: OverlayTriggerPlacement
  fluid?: boolean
}

interface PopoverProps {
  children?: React.ReactNode
  initialIsVisible?: boolean
  placement?: OverlayTriggerPlacement
  overlay?: React.ReactElement<{ placement?: OverlayTriggerPlacement }>
}

export const Content = React.forwardRef<
  HTMLDivElement,
  DivAttributes & ContentProps
>(
  (
    {
      children,
      className,
      placement = PlacementNS.top,
      fluid = false,
      ...props
    },
    ref
  ) => (
    <div ref={ref} className={cx('core-popover__container')}>
      <span
        className={cx(
          'core-popover',
          {
            'core-popover--fluid': fluid,
          },
          `core-popover--${placement}`,
          className
        )}
        {...props}
      >
        {children}
      </span>
    </div>
  )
)

const Popover = ({
  children,
  initialIsVisible = false,
  placement = PlacementNS.top,
  overlay,
  ...props
}: PopoverProps) => (
  <OverlayTrigger
    {...{
      initialIsVisible,
      overlay: isReactElement(overlay) ? (
        React.cloneElement(overlay, { placement })
      ) : (
        <></>
      ),
      placement,
      ...props,
    }}
  >
    {children}
  </OverlayTrigger>
)

Content.displayName = 'Popover.Content'

export default addSubcomponents(
  {
    Content,
  },
  Popover
)
